module.exports = __webpack_public_path__ + "img/feishu_oauth2.c9f769b6.png";